"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGISTER_USER_LIMIT_REACHED = exports.REGISTER_USER_FAILED = exports.REGISTER_USER_FAILED_USERNAME_EXISTS = exports.REGISTER_USER_FAILED_USER_EXISTS = exports.REGISTER_USER_SUCCEEDED = exports.REGISTER_USER_REQUESTED = void 0;
const service_1 = __importDefault(require("../../services/userMgmt/service"));
const modalSpinner_1 = require("../app/modalSpinner");
exports.REGISTER_USER_REQUESTED = "REGISTER_USER_REQUESTED";
exports.REGISTER_USER_SUCCEEDED = "REGISTER_USER_SUCCEEDED";
exports.REGISTER_USER_FAILED_USER_EXISTS = "REGISTER_USER_FAILED_USER_EXISTS";
exports.REGISTER_USER_FAILED_USERNAME_EXISTS = "REGISTER_USER_FAILED_USERNAME_EXISTS";
exports.REGISTER_USER_FAILED = "REGISTER_USER_FAILED";
exports.REGISTER_USER_LIMIT_REACHED = "REGISTER_USER_LIMIT_REACHED";
function default_1(username) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        dispatch(modalSpinner_1.startSpinning());
        const requestEvent = {
            type: exports.REGISTER_USER_REQUESTED,
            payload: username
        };
        dispatch(requestEvent);
        const result = yield service_1.default.registerUser(username);
        let outcomeEvent;
        switch (result.kind) {
            case "success":
                outcomeEvent = {
                    type: exports.REGISTER_USER_SUCCEEDED,
                    payload: result.myProfile
                };
                break;
            case "userExists":
                outcomeEvent = {
                    type: exports.REGISTER_USER_FAILED_USER_EXISTS
                };
                break;
            case "usernameTaken":
                outcomeEvent = {
                    type: exports.REGISTER_USER_FAILED_USERNAME_EXISTS,
                    payload: username
                };
                break;
            case "userLimitReached":
                outcomeEvent = {
                    type: exports.REGISTER_USER_LIMIT_REACHED,
                    payload: result.userLimit
                };
                break;
            case "httpError":
                outcomeEvent = {
                    type: exports.REGISTER_USER_FAILED,
                    httpError: result
                };
                break;
        }
        dispatch(outcomeEvent);
        dispatch(modalSpinner_1.stopSpinning());
        return outcomeEvent;
    });
}
exports.default = default_1;
